import { Noir } from './noir.preset';

/**
 * Единая theme-конфигурация PrimeNG для ОБОИХ приложений воркспейса —
 * админки (`src/app/app.config.ts`) и embeddable-виджета
 * (`projects/widget/src/app/app.config.ts`). Оба зовут
 * `providePrimeNG({ theme: primeNgTheme })`.
 *
 * Почему одним объектом, а не копипастой в двух app.config'ах: виджет
 * поднимается ВНУТРИ документа админки (agent-edit подключает его loader
 * для превью в секции «Виджет»), и его PrimeNG переписывает те же самые
 * `<style data-primeng-style-id="…">`, которые создала админка — useStyle
 * ищет их document-wide querySelector'ом и правит textContent на месте.
 *
 * Пока обе сборки генерируют одинаковый CSS, перезапись безвредна. Стоит
 * `darkModeSelector` разъехаться — и тёмная тема админки ломается целиком
 * (SKN-425: у задеплоенного виджета стоял `darkModeSelector: false`,
 * из переписанного CSS пропали ВСЕ dark-правила, и тёмная админка
 * отрисовалась светлыми токенами PrimeNG — белые инпуты, селекты и
 * карточки поверх тёмного фона).
 */
export const primeNgTheme = {
  preset: Noir,
  options: {
    // Тёмную тему включает класс `.p-dark`: ThemeService вешает его на
    // <html> (глобальная тема приложения), а agent-test — на .tg-card и
    // overlay-попапы виджета. Noir уже содержит dark colorScheme, никаких
    // hex'ов руками.
    //
    // Селекторов ДВА, и оба нужны:
    //
    //   '.p-dark'       — вложенные тёмные «острова»: виджет вешает класс
    //                     на .tg-card и на overlay-попапы, которые
    //                     монтируются в body.
    //   ':root.p-dark'  — корневая тема платформы, но со специфичностью
    //                     (0,1,1) вместо (0,1,0).
    //
    // Второй — про каскад. Светлые токены PrimeNG эмитит в `:root,:host`,
    // ровно с той же специфичностью, что и `.p-dark`, поэтому спор решает
    // порядок в документе. Стоит чужому PrimeNG (виджет-бандл на той же
    // странице) дописать в <head> СВОЙ светлый `:root,:host` позже нашего
    // — и он побеждает. `:root.p-dark` весит больше и остаётся сверху
    // независимо от порядка.
    //
    // PrimeNG принимает массив: ThemeUtils.regex.resolve делает
    // `[selector].flat()` и генерит по правилу на каждый (проверено на
    // сгенерированном CSS v21).
    darkModeSelector: ['.p-dark', ':root.p-dark'],
  },
};
